import React from 'react';
import { Spin } from 'antd';
import Modal from './modal';
import ExploreText from './exploreText';
import { connect } from 'react-redux';
import { getLiveStreamingURL } from '../actions/actions';
import ReactPlayer from 'react-player';

class HomeContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      streamingLink: '',
      message: '',
      isContentLoading: true,
      visible: false,
    };
  }

  componentDidMount = () => {
    this.props.getLiveStreamingURL().then(() => {
      const { liveURL } = this.props;
      if (liveURL.url) {
        this.setState({
          streamingLink: liveURL.url,
          isContentLoading: false,
          message: liveURL.message,
        });
      } else {
        this.setState({
          streamingLink: '',
          message: liveURL.message,
          isContentLoading: false,
        });
      }
    });
  };

  handleExploreClick = e => {
    e.preventDefault();
    this.setState({
      visible: true,
    });
  };

  setModalStatus = status => {
    this.setState({
      visible: status,
    });
  };

  render() {
    const { message, streamingLink, isContentLoading, visible } = this.state;
    const videoFrame = streamingLink ? (
      <div className='video-wraper'>
        <ReactPlayer
          url={streamingLink}
          playing={true}
          controls={true}
          width='100%'
          height='300px'
        />
        <label style={{ color: 'white' }}>{message}</label>
      </div>
    ) : (
      <div className='video-wraper'>
        <ReactPlayer
          url={'abc.com'}
          playing={false}
          controls={true}
          width='100'
          height='90'
        />
        <label style={{ color: 'white' }}>{message}</label>
      </div>
    );
    return (
      <article className='home-pattern'>
        {visible && (
          <Modal
            getModalStatus={this.setModalStatus}
            visible={visible}
            title={'Learn More'}
            message={<ExploreText />}
          />
        )}
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='lft-txt-wraper'>
                <h2>IMAM ABU YUSUF ACADEMY</h2>
                <p>
                  The official online platform containing all speeches and Live
                  talks from Shaykhul Hadith Hadhrat Mawlana Muhammad Bilal
                  Sahib.
                </p>
                <span>
                  <a
                    href='javascript:void(0);'
                    onClick={this.handleExploreClick}
                  >
                    Learn More
                  </a>
                </span>
              </div>
            </div>
            <div className='col-md-6'>
              <Spin tip='' spinning={isContentLoading}>
                {videoFrame}
              </Spin>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { homeData } = state;
  if (homeData !== null)
    return {
      liveURL: homeData,
    };
  return {
    liveURL: null,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getLiveStreamingURL: () => dispatch(getLiveStreamingURL()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeContent);
